import React from 'react';
import { Container, Grid } from '@mui/material';
import '../Disclaimer.css'

const Disclaimer = () => {
    return (
        <Container fixed className="fade-in">
        <Grid container className="main" justifyContent="center">
            <Grid item xs={12} style={{ paddingTop:'30px', textAlign:'center' }}>
                <h1>
                    Disclaimer &amp; License Information
                </h1>
            </Grid>
            <Grid item xs={12} justifyContent="flex-start" style={{ paddingTop:'20px' }}>
                <h4 style={{ fontWeight:900, fontSize:'12px' }}>
                    Disclaimer
                </h4>
                <p style={{ fontWeight:500, fontSize:'12px', lineHeight:'16px', marginTop:'20px' }}>
                    The contents of this Solution Advisor are presented for informational purposes only, and while effort has been made to ensure their accuracy, they are not to be construed as warranties or guarantees, express or implied, regarding the products or services described herein or their use or applicability. All sales are governed by our terms and conditions, which are available on request. We reserve the right to modify or improve the designs or specifications of our products at any time without notice.
                </p>
            </Grid>
            <Grid item xs={12} justifyContent="flex-start" style={{ paddingTop:'20px' }}>
                <h4 style={{ fontWeight:900, fontSize:'12px' }}>
                    Copyright Notices &amp; License Information
                </h4>
            </Grid>
            <Grid item xs={12} justifyContent="flex" style={{ padding:'0px 20px' }}>
                <p style={{ fontWeight:500, fontSize:'12px', marginTop:'5px', marginBottom:'5px' }}>
                    This product includes Software licensed for distribution under MIT License, such as:
                </p>
            </Grid>
            <Grid item xs={12} justifyContent="flex" style={{ padding:'0px 40px' }}>
                <ul style={{ fontWeight:500, fontSize:'12px' }}>
                    <li><a style={{ color:'#00AA7E' }} href="https://www.newtonsoft.com/json">Newtonsoft.Json</a> Copyright © 2007 James Newton-King</li>
                    <li><a style={{ color:'#00AA7E' }} href="https://getbootstrap.com/2.0.2/">Twitter Bootstrap</a> Copyright © 2011-2021 Twitter, Inc.</li>
                    <li><a style={{ color:'#00AA7E' }} href="https://jquery.com/">JQuery JavaScript Library</a> Copyright © 2021</li>
                    <li><a style={{ color:'#00AA7E' }} href="https://markjs.io/" target="_blank" rel="noreferrer">Mark.Js</a> Copyright &copy; 2014-2019 Julian Kuhnel</li>
                    
                </ul>
            </Grid>
            <Grid item xs={12} justifyContent="flex-start">
                <p style={{ fontWeight:500, fontSize:'12px', marginTop:'20px' }}>
                    This product includes fonts licensed for distribution under&nbsp;<a href="https://fonts.google.com/noto/specimen/Noto+Sans/about" style={{ color: '#00AA7E' }}>Open Font License</a>.
                </p>
            </Grid>
        </Grid>
        </Container>
    )
}

export default Disclaimer;